// extracted by mini-css-extract-plugin
export default {"header":"header-step_header__u5EgK","box":"header-step_box__xFoCj","logo":"header-step_logo__-k66q"};